const SearchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
        <path d="M65.8105 58.0238a30.4474 30.4474 0 00-50.3052-34.3156 30.4307 30.4307 0 0042.29 42.29c.4028.4028 17.9633 20.7424 17.9633 20.7424a8.1509 8.1509 0 0011.1566 2.3763c3.9874-2.3763 4.7929-7.1692 2.3763-11.1566a6.6324 6.6324 0 00-2.3763-2.3763c.0405.4031-20.7019-17.1575-21.1047-17.5602zM40.678 61.6084A20.7424 20.7424 0 1161.42 40.866a20.6111 20.6111 0 01-20.742 20.7424z"/>
    </svg>
  )
};

export default SearchIcon;